import type { RouteRecordRaw } from 'vue-router';
import { CUSTOMER_ROUTE_NAME } from '@/consts';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

/**
 * The canonical checkout URL resolves to a thin flag SHELL (`CheckoutShell.vue`): the
 * ORIGINAL v1 checkout (`CustomerCheckout.vue`) by default and, only when the
 * `orders-model` flag is on, the async-loaded v2 order-spine page — the v2 chunk is
 * lazy, so the off-flag bundle never includes any v2 order-spine code.
 */
export const customerCheckoutRoutes: RouteRecordRaw = {
  path: '/customer-checkout',
  component: () => import('@/layouts/main.vue'),
  meta: { requireAuth: true, requireStoreId: true, i18n },
  children: [
    {
      name: CUSTOMER_ROUTE_NAME.CUSTOMER_CHECKOUT,
      path: '',
      component: () => import('./CheckoutShell.vue'),
    },
  ],
};
